import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const ContentSection = styled(Box)`
  padding: 12px;
  overflow-y: hidden;
  border-top: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
`;
export const ContentSectionItem = styled(Box)`
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  border-radius: 5px;
`;
